import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from "moment/moment";
import { adminDetailAction } from "../../Redux/Action/manageAdminAction";
import { teacherDetailAction } from "../../Redux/Action/teacherAction";

export default function OrganisationGroupsStaffDetail() {
  const { id, type } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [staffData, setStaffData] = useState({});

  useEffect(() => {
    if (!id) return;
    const fetch = async () => {
      setIsLoading(true);
      if (type === "Teacher") {
        const res = await dispatch(teacherDetailAction(id));
        console.log("teacherDetailAction response:", res);
        if (res?.payload?.data) setStaffData(res.payload.data);
      } else {
        
        const res = await dispatch(adminDetailAction(id));
        console.log("adminDetailAction response:", res);
        if (res?.payload?.data) setStaffData(res.payload.data);
      }
      setIsLoading(false);
    };
    fetch();
  }, [dispatch, id, type]);

  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <p className="organization-crumb">Organisation Group / Staff</p>
          <div className="back-page-title">
            <button onClick={() => navigate(-1)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  d="M13.75 5.5L8.25 11L13.75 16.5"
                  stroke="#CCD2E3"
                  strokeWidth="2"
                />
              </svg>
            </button>
            <h2>
              {staffData.firstName} {staffData.surName}
            </h2>
          </div>
        </div>

        <Row className="my-3 add-class-gap">
          
          <Col xxl={4} md={12} className="display-table">
            <div className="cmn-card-color table-cell">
              <div className="student-view teacher">
                <img
                  src={
                    staffData.image
                      ? staffData.image
                      : require("../../Assets/Images/girl.png")
                  }
                  alt="staff avatar"
                />
                <h2>
                  {staffData.firstName} {staffData.surName}
                </h2>
                <p>{staffData?.schoolId?.schoolName}</p>
                <p>{staffData?.department}</p>
                <div className="students-dates">
                  <div>
                    <h3>
                      {staffData?.updatedAt
                        ? moment(staffData.updatedAt).format("DD/MM/YYYY")
                        : null}
                    </h3>
                    <p>Created</p>
                  </div>
                  <div>
                    <h3>
                      {staffData?.lastActiveDate
                        ? moment(staffData.lastActiveDate).format("DD/MM/YYYY")
                        : "---"}
                    </h3>
                    <p>Last Active</p>
                  </div>
                </div>
                <div className="students-dates">
                  <div>
                    <p>Contact</p>
                    <h3>E: {staffData.email}</h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          
          <Col xxl={4} md={12} className="display-table">
            <div className="class-detail-sec teacher table-cell">
              <div className="d-flex justify-content-between">
                <h2>Collections</h2>
              </div>
              <div className="scroll-add position-relative">
                <Row>
                  <>
                    {Array.isArray(staffData?.collectionId) &&
                    staffData.collectionId.length > 0 ? (
                      <>
                        {staffData.collectionId.map((ele, index) => (
                          <Col lg={12} className="mt-2" key={index}>
                            <div className="collection-video-inner">
                              <Row>
                                <Col lg={3} md={3} sm={3} xs={4}>
                                  <img
                                    src={
                                      ele?.image
                                        ? ele.image
                                        : require("../../Assets/Images/clogo.png")
                                    }
                                    alt={ele?.name}
                                    onError={(e) => {
                                      e.target.src = require("../../Assets/Images/clogo.png");
                                    }}
                                  />
                                </Col>
                                <Col lg={6} md={7} sm={7} xs={6}>
                                  <div className="count-section">
                                    <h3>{ele.name}</h3>
                                    <p
                                      style={{
                                        fontSize: "10px",
                                        color: "#2B3674",
                                        margin: "0 0 5px 0",
                                        lineHeight: "6px",
                                      }}
                                    >
                                      Created by:{" "}
                                      <>
                                        {ele?.createdBy === "Teacher" && (
                                          <>
                                            {ele?.teacherId?.firstName}{" "}
                                            {ele?.teacherId?.surName}
                                          </>
                                        )}
                                        {ele?.createdBy === "School" && (
                                          <>{ele?.schoolId?.schoolName}</>
                                        )}
                                        {ele?.createdBy === "SchoolAdmin" && (
                                          <>
                                            {ele?.schoolAdminId?.firstName}{" "}
                                            {ele?.schoolAdminId?.surName}
                                          </>
                                        )}
                                        {ele?.createdBy === "Student" && (
                                          <>
                                            {ele?.studentId?.name}
                                            {ele?.studentId?.firstName}{" "}
                                            {ele?.studentId?.surName}
                                          </>
                                        )}
                                      </>
                                    </p>
                                    <div className="count-desc pt-1">
                                      <p>
                                        Shared with{" "}
                                        {ele?.sharedWithStudentsCount ?? 0}{" "}
                                        student
                                        {ele?.sharedWithStudentsCount === 1
                                          ? ""
                                          : "s"}
                                      </p>
                                      <p>
                                        Shared with{" "}
                                        {ele?.sharedWithTeachersOrAdminsCount ??
                                          0}{" "}
                                        teacher
                                        {ele?.sharedWithTeachersOrAdminsCount ===
                                        1
                                          ? ""
                                          : "s"}
                                      </p>
                                    </div>
                                  </div>
                                  <p>
                                    Created on{" "}
                                    {ele?.createdAt
                                      ? moment(ele.createdAt).format(
                                          "DD/MM/YYYY"
                                        )
                                      : null}
                                  </p>
                                </Col>
                                <Col
                                  lg={3}
                                  md={2}
                                  sm={2}
                                  xs={2}
                                  className="video-count-sec"
                                >
                                  <div className="videos-count">
                                    <p className="text-end">
                                      {Array.isArray(ele?.video) &&
                                      ele.video.length > 0
                                        ? ele.video.length
                                        : 0}{" "}
                                      videos
                                    </p>
                                  </div>
                                  <div className="security-sec bottom-0 d-flex gap-2">
                                    {ele?.accessType === "PUBLIC" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="11"
                                          height="14"
                                          viewBox="0 0 11 14"
                                          fill="none"
                                        >
                                          <rect
                                            x="1"
                                            y="5.6152"
                                            width="9.23077"
                                            height="7.38474"
                                            rx="1"
                                            stroke="#201A46"
                                            strokeWidth="0.8"
                                            strokeLinejoin="round"
                                          />
                                          <rect
                                            x="4.75"
                                            y="8.50015"
                                            width="1.49944"
                                            height="1.49946"
                                            rx="0.74972"
                                            stroke="#201A46"
                                            strokeWidth="0.8"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M7.92398 2.97805V2.97805C7.92398 1.88561 7.03838 1 5.94593 1H5.61629C4.34178 1 3.30859 2.03319 3.30859 3.30769V5.61546H5.61629"
                                            stroke="#201A46"
                                            strokeWidth="0.8"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                        <p>Public</p>
                                      </>
                                    )}
                                    {ele?.accessType === "PRIVATE_GROUP" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <circle
                                            cx="9.5"
                                            cy="12.5"
                                            r="2.5"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                          />
                                          <path
                                            d="M14 19.75C14 21.8211 11.5711 22 9.5 22C7.42893 22 5 21.8211 5 19.75C5 17.6789 7.42893 16 9.5 16C11.5711 16 14 17.6789 14 19.75Z"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                          />
                                          <path
                                            d="M13.5527 14.7711C14.6631 14.7711 15.5633 13.8709 15.5633 12.7605C15.5633 11.6501 14.6631 10.75 13.5527 10.75"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                          />
                                          <path
                                            d="M16.5685 18.9999C16.5685 17.2252 15.2379 15.6654 13.5527 14.771"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                          />
                                          <path
                                            d="M5.01562 14.7711C3.90524 14.7711 3.00509 13.8709 3.00509 12.7605C3.00509 11.6501 3.90524 10.75 5.01562 10.75"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                          />
                                          <path
                                            d="M1.99982 18.9999C1.99982 17.2252 3.33042 15.6654 5.01562 14.771"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                          />
                                          <rect
                                            x="15"
                                            y="4.15356"
                                            width="6.30769"
                                            height="5.04615"
                                            rx="1"
                                            stroke="#99A1BB"
                                            strokeLinejoin="round"
                                          />
                                          <rect
                                            x="17.5625"
                                            y="6.125"
                                            width="1.025"
                                            height="1.025"
                                            rx="0.5125"
                                            stroke="#99A1BB"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M16.5781 2.57692C16.5781 1.70601 17.2841 1 18.155 1V1C19.026 1 19.732 1.70601 19.732 2.57692V4.15385H18.155H16.5781V2.57692Z"
                                            stroke="#99A1BB"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                        <p>Share Only</p>
                                      </>
                                    )}
                                    {ele?.accessType === "PRIVATE" && (
                                      <>
                                        <svg
                                          className="private"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="20"
                                          viewBox="0 0 16 20"
                                          fill="none"
                                        >
                                          <rect
                                            x="1"
                                            y="8"
                                            width="14"
                                            height="11.2"
                                            rx="1"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinejoin="round"
                                          />
                                          <rect
                                            x="6.6875"
                                            y="12.375"
                                            width="2.275"
                                            height="2.275"
                                            rx="1.1375"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M4.5 4.5C4.5 2.567 6.067 1 8 1V1C9.933 1 11.5 2.567 11.5 4.5V8H8H4.5V4.5Z"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                        <p>Private</p>
                                      </>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        ))}
                      </>
                    ) : (
                      <Container fluid>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "400px",
                          }}
                        >
                          <p className="data-not-found-cmn">No Data Found</p>
                        </div>
                      </Container>
                    )}
                  </>
                </Row>
              </div>
            </div>
          </Col>

          
          <Col xxl={4} md={12} className="display-table">
            <div className="cmn-card-color teacher table-cell">
              <div className="d-flex justify-content-between">
                <h2 className="f-24">All Classes</h2>
              </div>
              <div className="scroll-add">
                {staffData &&
                Array.isArray(staffData?.classId) &&
                staffData.classId.length > 0 ? (
                  <>
                    {staffData.classId.map((ele, index) => (
                      <Row key={index}>
                        <Col lg={6} className="mt-2">
                          <div className="classes-inner">
                            <p className="text-right">8 students</p>
                            <h3>Year {ele?.group}</h3>
                            <h2>{ele?.name}</h2>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                ) : (
                  <Row>
                    <p className="data-not-found-cmn">No Data Found</p>
                  </Row>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
